import "flatpickr";
import "flatpickr/dist/flatpickr.css";
import flatpickr from "./avt-flatpickr.js";
import echarts from "./echarts/index.js";
import floatingMenu from "./floating-menu.js";
import floatingTooltip from "./floating-tooltip.js";
import i18nText from "./i18n-text.js";
import intlTelInput from "./intl-tel-input.js";
import stringToHtml from "./string-to-html.js";
import webIntl from "./web-intl.js";

// Vite has no awareness of the elm-watch code.
// So it doesn't have enough context to auto include the web components.
// There's a couple things we can do, but it'simple enough to create a function to initialize the web component, and call it from JS.
// That seems to bypass the issue.

flatpickr.init();
echarts.init();
floatingMenu.init();
floatingTooltip.init();
i18nText.init();
intlTelInput.init();
stringToHtml.init();
webIntl.init();
